import { ResetPasswordContainer } from '@/modules/Auth';

const SignIn = (): JSX.Element => <ResetPasswordContainer />;

export default SignIn;
